import React from "react";
import { motion } from "framer-motion";
import { useT } from "@/context/LanguageContext";

export default function Manifesto({ chapters = [] }) {
  const { t, ui } = useT();
  return (
    <section
      id="manifiesto"
      className="relative bg-[color:var(--gcs-emerald)] text-[color:var(--gcs-ivory)] py-24 md:py-40 with-grain"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-4">
            <div className="md:sticky md:top-32">
              <p className="overline text-[color:var(--gcs-gold)] mb-6">{ui("manifesto.chapter")}</p>
              <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-[color:var(--gcs-ivory)]">
                {ui("manifesto.h1_a")}<em className="text-[color:var(--gcs-gold)]">{ui("manifesto.h1_em")}</em>{ui("manifesto.h1_b")}
              </h2>
              <div className="mt-8 flex items-center gap-3 text-[color:var(--gcs-ivory)]/60">
                <span className="h-px w-10 bg-[color:var(--gcs-gold)]" />
                <span className="overline text-[color:var(--gcs-gold)]">{ui("manifesto.subline")}</span>
              </div>
            </div>
          </div>

          <div className="md:col-span-8 space-y-16 md:space-y-24">
            {chapters.map((c, i) => (
              <motion.article
                key={c.id || i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start border-t border-[color:var(--gcs-line-dark)] pt-10"
                data-testid={`manifesto-chapter-${i}`}
              >
                <div className="md:col-span-3">
                  <span className="font-serif italic text-6xl md:text-7xl text-[color:var(--gcs-gold)]/50 leading-none block">
                    {c.number}
                  </span>
                </div>
                <div className="md:col-span-9">
                  <h3 className="font-serif text-3xl md:text-4xl text-[color:var(--gcs-ivory)] mb-4">
                    {t(c.title)}
                  </h3>
                  <p className="text-[color:var(--gcs-ivory)]/70 text-base md:text-lg leading-relaxed max-w-2xl">
                    {t(c.body)}
                  </p>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
